<template>
    <div v-loading="loading">
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr; gap: 20px">
            <el-input @change="filterOkrs" clearable placeholder="Tìm kiếm theo tên" v-model="filters.name" />
            <el-select v-model="filters.quarter" clearable @change="filterOkrs" placeholder="Chọn quý">
                <el-option
                    v-for="item in quarterOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-date-picker
                v-model="filters.year"
                format="yyyy" class="w-100"
                value-format="yyyy"
                type="year" @change="filterOkrs"
                placeholder="Chọn năm">
            </el-date-picker>
        </div>
        <span style="padding-top: 20px; display: block">Tổng số EXP bạn đạt được là: <span style="font-weight: 700;">{{totalExp}} Exp</span></span>
        <div class="example-preview table-responsive overflow-auto mt-3">
            <table class="table text-left table-hover table-bordered table-vertical-center b-table">
                <thead>
                <tr style="background-color: #472F92; color: white">
                    <th style="width: 50px">STT</th>
                    <th style="width: 250px">Tên OKR</th>
                    <th style="width: 200px">Phòng ban</th>
                    <th style="width: 100px">Quý</th>
                    <th style="width: 120px">Phân loại</th>
                    <th style="width: 150px">Số Exp tôi đạt được</th>
                    <th style="width: 150px">Người lead</th>
                    <th style="width: 150px">Trạng thái</th>
                    <th style="width: 90px">Tiến độ</th>
                    <th style="width: 350px;">Nhận xét</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="dataResultOkrs?.length > 0">
                    <tr v-for="(item, index) in dataResultOkrs" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>
                            <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                <span class="line-clamp-1">{{ item.name }}</span>
                            </el-tooltip>
                        </td>
                        <td>
                            <el-tooltip class="item" effect="dark" :content="item.department" placement="top">
                                <span class="line-clamp-1">{{ item.department }}</span>
                            </el-tooltip>
                        </td>
                        <td>
                            <span style="white-space: nowrap">{{ item?.fiscalQuarter }}</span>
                        </td>
                        <td>
                            <span :class="item.bgType">{{ item?.typeString }}</span>
                        </td>
                        <td>{{ item?.exp }}</td>
                        <td>{{ item?.leader }}</td>
                        <td>
                            <span :class="item.bgStatus">{{ item.status }}</span>
                        </td>
                        <td>
                            <span>{{ item.deadline }}</span>
                        </td>
                        <td>
                            <el-tooltip class="item" effect="dark" :content="item.comment" placement="top">
                                <span class="line-clamp-1">{{ item.comment }}</span>
                            </el-tooltip>
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <tr>
                        <td colspan="10" class="text-center">Chưa có dữ liệu</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { quarterOptions, ResultOkrModel } from "./model/OkrModel";
import { GET_RESULT_OKR } from "@/core/services/store/okrs/okr.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import moment from "moment-timezone";

export default {
    name: 'ResultOkrs',
    components: {},
    data() {
        return {
            quarterOptions,
            filters: {
                name: null,
                quarter: null,
                year: null
            },
            loading: false,
            dataResultOkrs: [],
            currentQuarter: 1,
            totalExp: 0,
        }
    },
    methods: {
        filterOkrs() {
            this.page = 1
            this.getResultOkrs()
        },
        getResultOkrs() {
            this.loading = true
            const payload = {
                name: this.filters.name,
                quarter: this.filters.quarter ?? this.currentQuarter,
                year: this.filters.year ?? Number(moment().format('YYYY'))
            }
            this.$store.dispatch(GET_RESULT_OKR, payload).then(res => {
                if (!res.error) {
                    this.totalExp = 0
                    this.dataResultOkrs = res.data.map(item => new ResultOkrModel(item)) ?? [];
                    res.data.map(item => {
                        this.totalExp += item?.exp
                    });
                }
            }).catch(e => {
                console.log(e)
            }).finally(() => this.loading = false)
        },
        getCurrentQuarter() {
            const month = Number(moment().format('M'));
            this.currentQuarter = Math.ceil(month / 3)
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Kết quả OKRs"}
        ]);
        this.getCurrentQuarter()
        this.getResultOkrs()
    },
}
</script>

<style scoped>
.color-green {
    color: #16a34a;
    font-weight: 600;
}
.color-red {
    color: #dc2626;
    font-weight: 600;
}
.color-warning {
    color: #d97706;
    font-weight: 600;
}
.color-violet {
    color: #3A057B;
}
</style>
